import React from "react";
// import { GoogleLogin } from "react-google-login";
import ButtonGoogleSubmit from "./ButtonGoogleSubmit";
import Loading from "../../assets/loading/laoding.svg";
import axios from "axios";
import AuthService from "../../services/auth.service";
import { useEffect } from "react";
import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";
import jwt_decode from "jwt-decode";

export default function ButoonGoogle({
  loading,
  setLoading,
  handleFailure,
  handleResponse,
}) {
  // useEffect(() => {
  //   const googleAuth = new GoogleAuth();
  //   googleAuth.setClientId(
  //     "612031410089-8t2urlv7s9hv5c18hflligg56ctovbdh.apps.googleusercontent.com"
  //   );
  // }, []);

  const getTokenGoogle = async (access_token) => {
    const {
      data: { given_name, family_name, picture, email, email_verified },
    } = await axios.get("https://openidconnect.googleapis.com/v1/userinfo", {
      params: {
        access_token: access_token,
      },
    });
    console.log(given_name, family_name, picture, email, email_verified);
  };
  const responseGoogle = async (access_token) => {
    setLoading(true);
    // console.log(response);
    // var decoded = jwt_decode(response.credential);
    // var name = decoded.given_name || "";
    // var email = decoded.email;
    // var imageUrl = decoded.picture || "";
    // var accessToken = decoded.jti;

    const {
      data: { given_name, family_name, picture, email, email_verified },
    } = await axios.get("https://openidconnect.googleapis.com/v1/userinfo", {
      params: {
        access_token: access_token,
      },
    });

    // console.log(given_name, family_name, picture, email, email_verified);

    axios
      .post(`${process.env.REACT_APP_API_URL}/auth/signup/google`, {
        name: given_name,
        email,
        imageUrl: picture,
        accessToken: access_token,
      })
      .then(async function (response) {
        try {
          await AuthService.login(email, access_token).then(
            async () => {
              handleResponse();
            },
            (error) => {
              handleFailure();
            }
          );
        } catch (err) {
          console.log(err);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const onFailure = (res) => {
    console.log("Login failed: res:", res);
    handleFailure();
  };

  const googleLogin = useGoogleLogin({
    onSuccess: (codeResponse) => responseGoogle(codeResponse.access_token),
  });

  return loading ? (
    <img
      src={Loading}
      alt=""
      className="w-full text-dark bg-white border border-neutral-200 rounded-lg h-10 py-1 flex flex-row items-center justify-center px-8 font-semibold my-1 hover:bg-gray"
    />
  ) : (
    // <GoogleLogin
    //   clientId={`612031410089-8t2urlv7s9hv5c18hflligg56ctovbdh.apps.googleusercontent.com`}
    //   buttonText="Login"
    //   render={(renderProps) => (
    //     <ButtonGoogleSubmit
    //       onClick={renderProps.onClick}
    //       disabled={renderProps.disabled}
    //     />
    //   )}
    //   onSuccess={responseGoogle}
    //   onFailure={onFailure}
    //   cookiePolicy={"single_host_origin"}
    //   isSignedIn={false}
    // />

    // <GoogleLogin
    //   className="text-dark bg-white border border-gray-light rounded-lg h-12 flex flex-row items-center w-9/12 justify-center px-1 font-semibold my-1 hover:bg-gray"
    //   onSuccess={responseGoogle}
    //   onError={onFailure}
    //   text="Continue with Google"
    //   size="large"
    //   useOneTap
    // />
    <div
      onClick={() => googleLogin()}
      className="text-dark bg-white border border-gray-light rounded-lg h-10 flex flex-row items-center w-full justify-center px-1 font-semibold my-1 hover:bg-gray hover:cursor-pointer"
    >
      <>
        <img src="/notebook/google.png" alt="" className="h-6 w-6 mx-1" />
        Continue with Google
      </>
    </div>
  );
}
